import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

export type UserProfileResponse = {
  timezoneCountry: string
  theme: 'Dark' | 'Light'
  phoneNumber: string
  fullName: string
  email: string
  businessEmail: boolean
  language: string
  locale: string
}
type QueryFnType = typeof getUserProfile

export const useGetUserProfile = () => {
  const { userId, setProfile } = useUserStore()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['userProfile', userId],
    queryFn: () => getUserProfile(userId),
    enabled: userId > 0,
    onSuccess: (data) => {
      if (!(data instanceof Error)) setProfile(data?.data)
    },
  })
  const data = query.data instanceof Error ? undefined : query.data?.data
  return { ...query, data }
}

const getUserProfile = async (userId: number | string) =>
  request<{ data: UserProfileResponse }>({ method: 'GET', url: `users/${userId}/profile` })
